import global from "@/prototype/global.js";

import {json_deep_clone, json_get_path, json_set_path} from "@/prototype/utils/JSON.js";

const log = global.log.getLogger("f_mtac.configuration.objectconfiguration");
log.setLevel(log.levels.WARN);

/**
 * @brief Handles a JSON configuration, used for the grid configuration.
 *        direct access via global.scene.map.grid.configuration
 * @param {string} name in name to be fin in the global_configuration
 * @param {} computed_configuration in provides a list of functions to be called associated with paths. 
 *          The function is called when the path is not in the configuration
 */
const ObjectConfiguration = function(name, computed_configuration) {
    var default_configuration; // json data
    if (name in global.default_configuration) {
        default_configuration = global.default_configuration[name];
    } else {
        default_configuration = {};
    }
    var configuration = undefined;
    
    /**
     * @brief Set the value of a given path
     * @param {Object} path, Object path
     * @param {*} value, Object value
     * @returns the input value if set
     */
    this.set = (path, value) => {
        if (configuration === undefined) {
            log.warn("ObjectConfiguration.set undefined");
            return;
        }
        log.debug("ObjectConfiguration.set", {path, value});
        json_set_path(configuration, path, value);
        return value;
    };

    /**
     * @brief Get the value of a given path. If the path is not in the json structure, try to use compute_configuration
     * @param {Object} path 
     * @returns the objects of the given path
     */
    this.get = (path) => {
        if (configuration === undefined) {
            log.debug("ObjectConfiguration.get undefined");
            return;
        }
        log.debug("ObjectConfiguration.get", {path, configuration});
        let value = json_get_path(configuration, path);
        if (typeof value !== "undefined") {
            return value;
        }
        value = json_get_path(computed_configuration, path);
        if (typeof value === "function") {
            return value(configuration, default_configuration);
        }
    };

    /**
     * @brief Reset JSON structure
     */
    this.unload = () => {
        configuration = undefined;
    };

    /**
     * @brief Reload the configuration with a given Object
     * @param {Object} object in
     */
    this.load = (object) => {
        log.debug("ObjectConfiguration.load", object);
        configuration = object;
    };

    /**
     * @brief returns the default configuration as a basic JSON structure, not an Object structure
     * @returns the default configuration as JSON data
     */
     this.default = () => {
        log.debug("ObjectConfiguration.default", default_configuration);
        return json_deep_clone(default_configuration);
    };

    /**
     * @brief Dump the configuration into a string
     * @returns a string with the configuration
     */
    this.dump = () => {
        return (JSON.stringify(configuration));
    };
};

export default ObjectConfiguration;
